<div class="header-container fx-layout-row fx-justify-start fx-align-baseline fx-gap-10">
  <div class="page-title">
    {{ globalBIReportLabel | translate }}
  </div>
</div>